import React, { Component } from 'react';
import AuthService from './AuthService';
export default function withAuth(AuthComponent) {
    const Auth = new AuthService('http://localhost/aec-backend/php-backend/public');
    return class AuthWrapped extends Component {
        constructor() {
            super();
            this.state = {
                user: null
            }
        }
        componentWillMount() {
            if (!Auth.loggedIn()) {
                this.props.history.replace('/login');  
            }
            else {
                try {
                    const profile = Auth.getProfile()
                    this.setState({
                        user: profile
                    })
                }
                catch(err){
                    Auth.logout()
                    this.props.history.replace('/login')
                }
            }
        }

        render() {
            if (this.state.user) {
                return (
                    <div>
                        <AuthComponent history={this.props.history} user={this.state.user} />
                    </div>
                )
            }
            else {
                return null
            }
        }
    };
}




// WEBPACK FOOTER //
// ./src/auth_components/js/withAuth.js